import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

export const useAuthToken = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [token, setToken] = useState(null);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        if (isAuthenticated) {
          const token = await getAccessTokenSilently();
          setToken(token);
        }
      } catch (error) {
      }
    };

    fetchToken();
  }, [isAuthenticated, getAccessTokenSilently]);

  return token;
};

